export default {
    compartimento: [],
    compartimentoPlanos: [],
    compartimentos: {},
    ultimaAtualizacaoCompartimento: Date
}